module.exports = __webpack_public_path__ + "add-on-ic.svg?2cd2c5a5ff2ec462a697c70c7debf3bb";